export const DATE_ERROR_MESSAGES = {
  minYears: 'Versicherter muss mindestens das {age}. Lebensjahr vollendet haben.'
};

export const PAYMENT_TYPE_ANNUAL = 1;

export const GENDER_MALE = 0;
export const GENDER_FEMALE = 1;
